<mat-form-field appearance="outline">
    <mat-select (selectionChange)="onSnapshotChange($event)" [(ngModel)]="this.defaultSnapshotID" [disabled]="readonly">
        <mat-option *ngFor="let snapshot of this.magoCloudService?.snapShotsList" [value]="snapshot.SnapshotId"
            >{{ snapshot.Description }} ({{ snapshot.SnapshotId }} v. {{ snapshot.Version }})
        </mat-option>
    </mat-select>
</mat-form-field>
